@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap');

* {
    margin: 0;
    padding: 0;
}
h1{
    color: gray;
    margin-right: 0;
}
body {
    font-family: 'Helvetica', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 5px;
    overflow: visible;
    height: 100%;
}

.App {
    height: 100%;
    flex-direction: row;
}
#outerShell{
    height: 100%;
}
